export default __webpack_public_path__ + "static/media/card5.1099c16d.svg";